import { type IconDefinition } from "@fortawesome/fontawesome-svg-core"

/* SOLID */
import {
  faArrowUpRight,
  faArrowRotateRight,
  faArrowRight,
  faBars,
  faBolt,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faDownToLine,
  faEarthAfrica,
  faEye,
  faFaceSmile,
  faHeadset,
  faMicrophone,
  faMicrophoneSlash,
  faMicrophoneSignalMeter,
  faLightbulb,
  faPlay,
  faPhoneHangup,
  faVolume,
  faVolumeSlash,
  faCircleXmark,
  faXmark,
  faUniversalAccess,
  faWaveformLines,
} from "@fortawesome/pro-solid-svg-icons"

/* THIN */
import {
  faAlicorn as fatAlicorn,
  faArrowRight as fatArrowRight,
  faArrowsRotate as fatArrowsRotate,
  faBolt as fatBolt,
  faCalendarClock as fatCalendarClock,
  faCircleExclamation as fatCircleExclamation,
  faCircleInfo as fatCircleInfo,
  faCircleQuestion as fatCircleQuestion,
  faCircleXmark as fatCircleXmark,
  faClock as fatClock,
  faClockRotateLeft as fatClockRotateLeft,
  faDoorOpen as fatDoorOpen,
  faEarListen as fatEarListen,
  faFaceSmile as fatFaceSmile,
  faGlobe as fatGlobe,
  faHandHoldingHeart as fatHandHoldingHeart,
  faLightbulb as fatLightbulb,
  faMicrophone as fatMicrophone,
  faPaperPlane as fatPaperPlane,
  faPartyHorn as fatPartyHorn,
  faPersonRunningFast as fatPersonRunningFast,
  faPersonToDoor as fatPersonToDoor,
  faQuestion as fatQuestion,
  faRocket as fatRocket,
  faRocketLaunch as fatRocketLaunch,
  faStars as fatStars,
  faTriangleExclamation as fatTriangleExclamation,
  faTrophyStar as fatTrophyStar,
  faUnicorn as fatUnicorn,
  faUniversalAccess as fatUniversalAccess,
  faUserClock as fatUserClock,
  faWandMagic as fatWandMagic,
  faWandMagicSparkles as fatWandMagicSparkles,
} from "@fortawesome/pro-thin-svg-icons"

/* LIGHT */
import { faRocket as falRocket } from "@fortawesome/pro-light-svg-icons"

/* DUOTONE */
import { faUnicorn as fadUnicorn } from "@fortawesome/pro-duotone-svg-icons"

export default [
  /* SOLID */
  faArrowUpRight,
  faArrowRotateRight,
  faArrowRight,
  faBars,
  faBolt,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleXmark,
  faDownToLine,
  faEarthAfrica,
  faEye,
  faFaceSmile,
  faHeadset,
  faMicrophone,
  faMicrophoneSlash,
  faMicrophoneSignalMeter,
  faLightbulb,
  faPlay,
  faPhoneHangup,
  faVolume,
  faVolumeSlash,
  faCircleXmark,
  faXmark,
  faUniversalAccess,
  faWaveformLines,

  /* THIN */
  fatAlicorn,
  fatArrowRight,
  fatArrowsRotate,
  fatBolt,
  fatCalendarClock,
  fatCircleExclamation,
  fatCircleInfo,
  fatCircleQuestion,
  fatCircleXmark,
  fatClock,
  fatClockRotateLeft,
  fatFaceSmile,
  fatGlobe,
  fatHandHoldingHeart,
  fatLightbulb,
  fatMicrophone,
  fatPartyHorn,
  fatPersonToDoor,
  fatQuestion,
  fatRocket,
  fatRocketLaunch,
  fatStars,
  fatTriangleExclamation,
  fatTrophyStar,
  fatUniversalAccess,
  fatUserClock,

  /* LIGHT */
  falRocket,

  /* DUOTONE */
  fadUnicorn,
  fatDoorOpen,
  fatFaceSmile,
  fatMicrophone,
  fatEarListen,
  fatPaperPlane,
  fatPersonRunningFast,
  fatUnicorn,
  fatWandMagic,
  fatWandMagicSparkles,
] as IconDefinition[]

export const AF_ICON = "🦄"
